(function () {
  document.addEventListener('theme:cart:loaded', function () {
    try {
      const cartDrawerForm = document.getElementById('cartDrawerCheckoutForm');

      if (!cartDrawerForm) {
        return;
      }

      const existingEmailInput = cartDrawerForm.querySelector(
        'input[name="checkout[email]"]',
      );
      if (existingEmailInput) {
        return;
      }

      const customerEmail = getCustomerSessionData('email');

      if (!customerEmail) {
        return;
      }

      const currentAction = cartDrawerForm.getAttribute('action');
      const separator = currentAction.includes('?') ? '&' : '?';

      cartDrawerForm.action = `${currentAction}${separator}checkout[email]=${customerEmail}`;
    } catch (error) {}
  });
})();
